<template>
  <div class="jobs-box">
    <div class="job-item" v-for="(item, index) in data" :key="index" @click="handleToDetail(item)">
        <div class="flex-between flex-center">
          <p class="post-name">{{item.job_post}}</p>
          <p class="salary">{{item.display_salary}}</p>
        </div>
        <div class="flex tags">
          <div class="tag-item">
            {{item.city_names[0] || '全国'}}
          </div>
          <div class="tag-item">
            {{item.display_experience || '不限'}}
          </div>
          <div class="tag-item">
            {{item.degree_name || "不限"}}
          </div>
          <template v-if="item.job_tags">
            <div v-for="(child, i) in item.job_tags.slice(0,1)" :key="i" class="tag-item">
              {{child}}
            </div>
          </template>

        </div>
        <div class="flex company-box">
          <img :src="item.company_logo"></img>
          <span class="company-name">{{item.company_nick_name || item.company_name}}</span>
        </div>
      </div>
    <div class="more-btn" @click="handleClickToList">
      更多职位
    </div>
  </div>
</template>

<script>
  export default {
    name: "Jobs",
    props:{
      data: Array
    },
    methods:{
      handleToDetail(item){
        this.$router.push(`/jobs/recommend/${item.token}`)
      },
      handleClickToList(){
        window.location.href = '/jobs/recommend'
      }
    }
  }
</script>

<style scoped lang="scss">
.jobs-box{
  padding: 30px 16px 40px 16px;
  margin-top: -6px;
  .job-item{
    width: 315px;
    background: #37158B;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    &:last-child{
      margin-bottom: 0;
    }
    .post-name{
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22px;
      flex: 1;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .salary{
      font-size: 16px;
      font-weight: 500;
      color: #FFCC44;
      line-height: 22px;
      text-align: right;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .tags{
      margin: 8px 0 12px;
      .tag-item{
        padding: 3px 8px;
        background-color: #4C21B7;
        font-size: 12px;
        font-weight: 400;
        color: #D5C3FF;
        line-height: 17px;
        border-radius: 2px;
        margin-right: 6px;
        *{
          white-space: nowrap;
        }
      }
    }
    .company-box{
      align-items: center;
      img{
        width: 24px;
        height: 24px;
        border-radius: 2px;
        margin-right: 8px;
      }
      .company-name{
        font-size: 14px;
        font-weight: 400;
        color: #D5C3FF;
        line-height: 12px;
      }
    }
  }
  .more-btn{
    width: 148px;
    height: 44px;
    background: linear-gradient(180deg, #EDC639 0%, #EC890E 100%);
    border-radius: 24px;
    line-height: 44px;
    margin: 26px auto 0;
    font-size: 16px;
    font-weight: 600;
    color: #FFFEEC;
    text-align: center;
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>